/* ---------------------------------------------------------------------------
   Badge label settling on first paint.

   price.liquid always renders the generic {{ 'products.product.sold_out' | t }},
   because Liquid has no idea which fit the shopper will land on. The JS then
   refines it to the contextual label ("Unavailable in Petite"), which reads as the
   badge changing its mind a second after the page appears.

   So the badge is held invisible until that first refinement lands. Two
   deliberate safeguards, because a permanently hidden sold-out badge is far worse
   than a late one:
     - the class is added BY SCRIPT, so if this file never runs the badge shows
       exactly as it does today;
     - a hard timeout reveals it regardless, so a thrown error upstream cannot
       leave it hidden.
   visibility (not display) keeps the space reserved, so nothing shifts.
--------------------------------------------------------------------------- */
(function () {
  var PENDING = 'ly-badge-pending';
  var FAILSAFE_MS = 1500;
  var root = document.documentElement;
  var revealed = false;
  var observer = null;
  var timer = null;

  function reveal() {
    if (revealed) return;
    revealed = true;
    root.classList.remove(PENDING);
    if (observer) observer.disconnect();
    clearTimeout(timer);
  }

  root.classList.add(PENDING);
  timer = setTimeout(reveal, FAILSAFE_MS);

  function watch() {
    var badge = null;
    try {
      badge = document.querySelector('.product:has(.product__media-wrapper) .price__badge-sold-out');
    } catch (e) {
      badge = null; // :has() unsupported
    }
    if (!badge) badge = document.querySelector('.product .price__badge-sold-out');
    if (!badge) return reveal();

    observer = new MutationObserver(reveal);
    observer.observe(badge, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

(function() {
  // Intercept URL variant parameter
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('variant')) {
    sessionStorage.setItem('pendingVariant', urlParams.get('variant'));
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString().replace(/variant=[^&]*&?/, '') : '');
    window.history.replaceState({}, '', newUrl);
  }
  
  // Listen for color swatch clicks - check for input with data-product-url
  document.addEventListener('click', (e) => {
    const colorInput = e.target.closest('input[data-product-url]');
    if (colorInput && colorInput.dataset.productUrl) {
      sessionStorage.setItem('colorChanged', 'true');
    }
  }, { capture: true });
  
  // Override the initial variant selection
  document.addEventListener('DOMContentLoaded', () => {
    
    const sizeSelects = Array.from(document.querySelectorAll('select')).filter(s => 
      window.lyIsOption(s, 'size') && s.name.startsWith('options[')
    );    
    
    // Function to reset fit buttons
    const resetFitButtons = () => {
      console.log('resetFitButtons called', new Date().getTime());
      const fits = Array.from(document.querySelectorAll('input')).filter(i => 
        window.lyIsOption(i, 'fit')
      );      
      
      if (fits.length > 0) {
        fits.forEach(input => {
          input.checked = false; // Uncheck
          input.disabled = false;
          input.classList.remove('disabled');
          
          const labelByFor = input.id ? document.querySelector(`label[for="${input.id}"]`) : null;
          const labelBySibling = input.nextElementSibling;
          
          if (labelByFor) {
            labelByFor.classList.remove('ly-variants__label-disabled');
          }
          if (labelBySibling && labelBySibling.tagName === 'LABEL') {
            labelBySibling.classList.remove('ly-variants__label-disabled');
          }
        });
      }
    };
    
    // Check if user just changed color
    const colorChanged = sessionStorage.getItem('colorChanged');
    
    if (colorChanged === 'true') {
      sessionStorage.removeItem('colorChanged');
      
      // Auto-select first available size after a delay
      setTimeout(() => {
        const sizeSelect = sizeSelects[0]; 
        if (sizeSelect) {
          const variantDataScript = document.querySelector('script[data-product-variants]');
          let allVariants = [];
          try {
            allVariants = JSON.parse(variantDataScript.textContent);
          } catch (e) {
            console.error('❌ Failed to parse variants:', e);
          }
          
          const firstAvailableVariant = allVariants.find(v => v.available);
          
          if (firstAvailableVariant) {
            const fitValues = ['REG', 'PETITE', 'TALL', 'LONG', 'Reg', 'Petite', 'Tall', 'Long'];
            let sizeValue = null;
            
            // Find the size option (not color, not fit)
            [firstAvailableVariant.option1, firstAvailableVariant.option2, firstAvailableVariant.option3].forEach(optionValue => {
              if (optionValue && !fitValues.includes(optionValue)) {
                // This might be the size - check if it exists in the size dropdown
                const sizeOption = Array.from(sizeSelect.options).find(opt => opt.value === optionValue);
                if (sizeOption) {
                  sizeValue = optionValue;
                }
              }
            });
            
            if (sizeValue) {
              sizeSelect.value = sizeValue;
              sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              console.log('❌ Could not determine size value');
            }
          } else {
            console.log('⚠️ No available variants found');
          }
        } else {
          console.log('❌ Size select not found');
        }
      }, 200);
    } else {
      // Normal page load - check for single size option
      if (sizeSelects.length === 1 && Array.from(sizeSelects[0].options).filter(opt => opt.value).length === 1) {
        // Only one dropdown with one option - auto-select it
        sizeSelects[0].value = Array.from(sizeSelects[0].options).find(opt => opt.value).value;
        sizeSelects[0].dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        sizeSelects.forEach(s => { s.value = ''; });
      }
    }
    
    // MutationObserver to show/hide fit fieldset based on visible options
    var domObserver = new MutationObserver(function() {
      var fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
      fieldsets.forEach(function(fitFieldset) {
        var fitInput = Array.from(fitFieldset.querySelectorAll('input')).find(i => 
          window.lyIsOption(i, 'fit')
        );
        
        if (!fitInput) return;
        
        var visibleLabels = Array.from(fitFieldset.querySelectorAll('label')).filter(function(label) {
          return label.style.display !== 'none';
        });
        
        if (visibleLabels.length > 1) {
          fitFieldset.style.display = 'block';
        } else if (visibleLabels.length === 1) {
          var input = fitFieldset.querySelector('input:not([style*="display: none"])');
          if (input) input.checked = true;
          fitFieldset.style.display = 'none';
        }
      });
    });

    domObserver.observe(document.body, { childList: true, subtree: true });

    resetFitButtons();
    setTimeout(resetFitButtons, 100);
    setTimeout(resetFitButtons, 300);
    setTimeout(resetFitButtons, 500);
    setTimeout(resetFitButtons, 1000);

    // Keep the sold-out badge visible when every variant is sold out —
    // only hide it (pending a size selection) if something is still available.
    let allSoldOut = false;
    const variantDataScript = document.querySelector('script[data-product-variants]');
    if (variantDataScript) {
      try {
        const variants = JSON.parse(variantDataScript.textContent);
        allSoldOut = variants.length > 0 && variants.every((v) => !v.available);
      } catch (e) {}
    }

    const soldOutBanner = document.querySelector('.product__inventory, .product-form__error-message-wrapper, .product:has(.product__media-wrapper) .price__badge-sold-out');
    if (soldOutBanner && !allSoldOut) {
      soldOutBanner.style.display = 'none';
    }
    
    const notifyMeButton = document.querySelector('swymcs-watchlist-button');
    if (notifyMeButton) {
      notifyMeButton.style.display = 'none';
    }
    
    document.body.classList.add('variants-ready');
  }, { capture: true });
})();

/* ---------------------------------------------------------------------------
   Correct the incoming product HTML before it is painted.

   A colour swatch points at a DIFFERENT product, and the swap requests that
   product with the CURRENT product's option_values, which mean nothing there. So
   Shopify renders that product's own defaults - often a sold-out variant - and the
   sold-out badge appears, then disappears a few seconds later once the theme's
   own passes settle on a real variant. That round trip is the flicker.

   Passing ?variant= does not help: the section still comes back with its defaults.
   So instead we look up the target product's variants (cheap JSON, cached per
   handle and prefetched on hover), then fix the parsed fragment in
   handleSwapProduct before it is inserted - the same trick the existing code
   already uses to hide the buttons pre-swap.

   Note: selection is written as ATTRIBUTES (checked / selected), not properties.
   The fragment is a detached document and only attributes survive adoption into
   the live DOM.
--------------------------------------------------------------------------- */
(function () {
  var pending = new Map();
  var ready = new Map();

  function handleFrom(productUrl) {
    if (!productUrl) return null;
    var parts = String(productUrl).split('/products/');
    if (parts.length < 2) return null;
    return parts[1].split('?')[0].split('#')[0];
  }

  window.LYVariantsFor = function (productUrl) {
    var handle = handleFrom(productUrl);
    if (!handle) return Promise.resolve(null);
    if (ready.has(handle)) return Promise.resolve(ready.get(handle));
    if (!pending.has(handle)) {
      pending.set(
        handle,
        fetch(window.lyUrl('products/' + handle + '.js'))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            var v = (d && d.variants) || null;
            if (v) ready.set(handle, v);
            return v;
          })
          .catch(function () { return null; })
      );
    }
    return pending.get(handle);
  };

  // Synchronous read - the swap needs an answer without awaiting. The lookup is
  // fired on hover and again on click, and the section fetch takes ~1.5s, so this
  // is normally populated by the time the fragment arrives. If it is not, we skip
  // the correction and behave exactly as before.
  window.LYVariantsReady = function (productUrl) {
    var handle = handleFrom(productUrl);
    return handle ? ready.get(handle) || null : null;
  };

  // Keep the shopper's size if it is available in this colour, else first available.
  window.LYPickTargetVariant = function (variants, preferredSize) {
    if (!variants || !variants.length) return null;
    var available = variants.filter(function (v) { return v.available; });
    if (preferredSize) {
      var keep = available.find(function (v) {
        return v.option1 === preferredSize || v.option2 === preferredSize || v.option3 === preferredSize;
      });
      if (keep) return keep;
    }
    return available[0] || variants[0];
  };

  window.LYPreselectIncoming = function (html, productUrl, preferredSize) {
    var variants = window.LYVariantsReady(productUrl);
    if (!variants) return false;

    var target = window.LYPickTargetVariant(variants, preferredSize);
    if (!target) return false;

    var scope = html.querySelector('product-info') || html.querySelector('main') || html;
    var values = [target.option1, target.option2, target.option3].filter(Boolean);
    var slice = function (nodes) { return Array.prototype.slice.call(nodes); };

    // Radio-rendered options (fit, and colour on some products)
    var groups = {};
    slice(scope.querySelectorAll('input[type="radio"]')).forEach(function (r) {
      (groups[r.name] = groups[r.name] || []).push(r);
    });
    Object.keys(groups).forEach(function (name) {
      var group = groups[name];
      var match = group.filter(function (r) { return values.indexOf(r.value) !== -1; })[0];
      if (!match) return;
      group.forEach(function (r) { r.removeAttribute('checked'); });
      match.setAttribute('checked', '');
    });

    // Select-rendered options (size)
    slice(scope.querySelectorAll('select')).forEach(function (sel) {
      var opts = slice(sel.options);
      var match = opts.filter(function (o) { return values.indexOf(o.value) !== -1; })[0];
      if (!match) return;
      opts.forEach(function (o) { o.removeAttribute('selected'); });
      match.setAttribute('selected', '');
    });

    // The badge is rendered for the default variant - clear it if ours is available
    if (target.available) {
      slice(scope.querySelectorAll('.price')).forEach(function (el) {
        el.classList.remove('price--sold-out');
        el.classList.remove('price--show-badge');
      });
      slice(scope.querySelectorAll('.price__badge-sold-out')).forEach(function (el) {
        el.style.display = 'none';
      });
    }

    var idInput = scope.querySelector('input[name="id"]');
    if (idInput) idInput.setAttribute('value', String(target.id));

    return true;
  };

  function warm(e) {
    var el = e.target && e.target.closest && e.target.closest('[data-product-url]');
    if (el && el.dataset.productUrl) window.LYVariantsFor(el.dataset.productUrl);
  }
  document.addEventListener('pointerover', warm, { capture: true, passive: true });
  document.addEventListener('focusin', warm, { capture: true, passive: true });
})();

(function () {
  'use strict';

  // ── Inject modal styles once ──────────────────────────────────────────────
  function injectModalStyles() {
    if (document.getElementById('ly-similar-modal-styles')) return;
    const style = document.createElement('style');
    style.id = 'ly-similar-modal-styles';
    style.textContent = `
      #ly-similar-modal-backdrop {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.45);
        z-index: 9998;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.25s ease;
      }
      #ly-similar-modal-backdrop.ly-visible {
        opacity: 1;
      }
      #ly-similar-modal {
        background: #fff;
        color: #1a1a1a;
        border-radius: 10px;
        padding: 2.25rem 2rem 1.75rem;
        max-width: 420px;
        width: calc(100% - 2rem);
        position: relative;
        box-shadow: 0 8px 40px rgba(0,0,0,0.18);
        transform: translateY(12px);
        transition: transform 0.25s ease;
        font-family: inherit;
      }
      #ly-similar-modal-backdrop.ly-visible #ly-similar-modal {
        transform: translateY(0);
      }
      #ly-similar-modal-close {
        position: absolute;
        top: 0.85rem;
        right: 0.9rem;
        background: none;
        border: none;
        cursor: pointer;
        padding: 0.25rem;
        line-height: 1;
        color: #888;
        font-size: 3rem;
      }
      #ly-similar-modal-close:hover { color: #1a1a1a; }
      #ly-similar-modal h2 {
        font-size: 1.5rem;
        font-weight: 600;
        margin: 0 0 0.5rem;
        letter-spacing: 0.01em;
      }
      #ly-similar-modal p {
        font-size: 14px;
        color: #555;
        margin: 0 0 1.5rem;
        line-height: 1.5;
      }
      #ly-similar-modal-cta {
        width: 100%;
        text-align: center;
        display: inline-block;
        background: #018849;
        color: #fff;
        text-decoration: none;
        padding: 0.75rem 1.5rem;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        border-radius: 4px;
        transition: background 0.15s;
      }
      #ly-similar-modal-cta:hover { background: #018849; }
    `;
    document.head.appendChild(style);
  }

  // ── Build / return the modal DOM ──────────────────────────────────────────
  function getOrCreateModal() {
    let backdrop = document.getElementById('ly-similar-modal-backdrop');
    if (backdrop) return backdrop;

    backdrop = document.createElement('div');
    backdrop.id = 'ly-similar-modal-backdrop';
    backdrop.setAttribute('role', 'dialog');
    backdrop.setAttribute('aria-modal', 'true');
    backdrop.setAttribute('aria-labelledby', 'ly-similar-modal-title');
    backdrop.innerHTML = `
      <div id="ly-similar-modal">
        <button id="ly-similar-modal-close" aria-label="${window.lyT('close', 'Close')}">&times;</button>
        <h2 id="ly-similar-modal-title">${window.lyT('similarTitle', 'Check out our other listing')}</h2>
        <p id="ly-similar-modal-body"></p>
        <div>
          <a id="ly-similar-modal-cta" href="#">${window.lyT('similarCta', 'This way to take a look')}</a>
        </div>
      </div>
    `;
    document.body.appendChild(backdrop);
    backdrop.style.display = 'none';

    const close = () => {
      backdrop.classList.remove('ly-visible');
      setTimeout(() => { backdrop.style.display = 'none'; }, 260);
    };

    document.getElementById('ly-similar-modal-close').addEventListener('click', close);
    backdrop.addEventListener('click', (e) => { if (e.target === backdrop) close(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && backdrop.classList.contains('ly-visible')) close();
    });

    // Focus trap
    backdrop.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const focusable = Array.from(backdrop.querySelectorAll('a[href], button:not([disabled])'));
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      }
    });

    return backdrop;
  }

  // ── Show the modal with copy and a CTA link ───────────────────────────────
  function showSimilarModal(variantUrl, selectedSize, selectedFit) {
    injectModalStyles();
    const backdrop = getOrCreateModal();

    const productTitle = window.LYProductTitle || window.lyT('similarFallbackTitle', 'this style');

    const fitPart = selectedFit ? ` in ${selectedFit}` : '';
    document.getElementById('ly-similar-modal-body').textContent =
    window.LYSimilarModalText || window.lyT('similarBody', 'Oh no! The [title] is out of stock in this size. Did you know we offer it, in a slightly different version?', { title: productTitle });
    document.getElementById('ly-similar-modal-cta').href = variantUrl;

    backdrop.style.display = 'flex';
    requestAnimationFrame(() => requestAnimationFrame(() => backdrop.classList.add('ly-visible')));
    setTimeout(() => { document.getElementById('ly-similar-modal-cta').focus(); }, 260);
  }

  // ── Fetch the linked product and find a matching in-stock variant ─────────
  function findMatchingInStockVariant(linkedProductId, currentOptionMap, callback) {
    fetch(window.lyUrl(`products/${linkedProductId}.js`))
      .then(r => r.json())
      .then(data => {
        const product = data;
        console.log('Linked product:', product?.handle);
        console.log('Linked product variants:', product?.variants);
        console.log('Current option map:', currentOptionMap);
        if (!product) { callback(null); return; }

        const ignoredOptionNames = ['colour', 'color'];

        const matchVariant = product.variants.find(v => {
          if (!v.available) return false;
        
          return currentOptionMap['size'] === undefined || (
            (v.option1?.toLowerCase() === currentOptionMap['size']?.toLowerCase() ||
             v.option2?.toLowerCase() === currentOptionMap['size']?.toLowerCase() ||
             v.option3?.toLowerCase() === currentOptionMap['size']?.toLowerCase())
            &&
            (currentOptionMap['fit'] === undefined ||
             v.option1?.toLowerCase() === currentOptionMap['fit']?.toLowerCase() ||
             v.option2?.toLowerCase() === currentOptionMap['fit']?.toLowerCase() ||
             v.option3?.toLowerCase() === currentOptionMap['fit']?.toLowerCase())
          );
        });
        console.log('options on linked product:', product.options);
        console.log('first variant:', product.variants[0]);
        console.log('looking for size:', currentOptionMap['size'], 'fit:', currentOptionMap['fit']);
        console.log('match attempt:', product.variants.map(v => ({
          option2: v.option2,
          option3: v.option3,
          available: v.available,
          sizeMatch: v.option2?.toLowerCase() === currentOptionMap['size']?.toLowerCase(),
          fitMatch: v.option3?.toLowerCase() === currentOptionMap['fit']?.toLowerCase()
        })));

        if (!matchVariant) { callback(null); return; }
        callback(`/products/${product.handle}?variant=${matchVariant.id}`);
      })
      .catch(() => callback(null));
  }

  window.LYCheckSimilarVariant = function (variant, productOptionNames) {
    if (!variant || variant.available) return;

    const linkedProductId = window.LYSimilarProductId;
    if (!linkedProductId) return;

    // Build lowercase option-name → value map for the OOS variant
    const currentOptionMap = {};
    productOptionNames.forEach((name, idx) => {
      const val = variant[`option${idx + 1}`];
      if (val) currentOptionMap[window.lyOptionType(name) || name.toLowerCase()] = val;
    });

    const selectedSize = currentOptionMap['size'] || '';
    const selectedFit  = currentOptionMap['fit']  || '';

    findMatchingInStockVariant(linkedProductId, currentOptionMap, (variantUrl) => {
      if (variantUrl) showSimilarModal(variantUrl, selectedSize, selectedFit);
    });
  };

})();

var ENABLE_NEW_VARIANT_SELECTION = window.ENABLE_NEW_VARIANT_SELECTION || false;

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      selectedSizeBeforeSwap = null; 

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        
        // 🆕 Only reset prices if no size is selected
        setTimeout(() => {
          const sizeSelect = Array.from(this.querySelectorAll('select')).find(s => 
            window.lyIsOption(s, 'size')
          );
          
          const sizeSelected = sizeSelect && sizeSelect.value && sizeSelect.value !== '';
          
          // If no size selected, reset to minimum prices
          if (!sizeSelected) {
            const variantDataScript = document.querySelector('script[data-product-variants]');
            if (variantDataScript) {
              try {
                const allVariants = JSON.parse(variantDataScript.textContent);
                const prices = allVariants.map(v => parseFloat(v.price)).filter(p => p > 0);
                const compareAtPrices = allVariants.map(v => parseFloat(v.compare_at_price)).filter(p => p > 0);
                
                const minPrice = Math.min(...prices);
                const minCompareAtPrice = compareAtPrices.length > 0 ? Math.min(...compareAtPrices) : null;
                
                const shopCurrency = window.Shopify?.currency?.active || 'GBP';

                const formattedPrice = new Intl.NumberFormat('en-GB', {
                  style: 'currency',
                  currency: shopCurrency
                }).format(minPrice / 100);
                
                const formattedComparePrice = minCompareAtPrice ? new Intl.NumberFormat('en-GB', {
                  style: 'currency',
                  currency: shopCurrency
                }).format(minCompareAtPrice / 100) : null;
                
                // Update sale price
                const salePriceEl = this.querySelector('.product:has(.product__media-wrapper) .price-item--sale');
                if (salePriceEl) {
                  salePriceEl.textContent = formattedPrice;
                }

                // Update compare-at (strikethrough) price - look inside price__sale
                const regularPriceInSale = this.querySelector('.product:has(.product__media-wrapper) .price__sale .price-item--regular');
                if (regularPriceInSale && formattedComparePrice) {
                  regularPriceInSale.textContent = formattedComparePrice;
                }

                // ALWAYS update the regular price section too (for non-sale items)
                const regPriceEl = this.querySelector('.product:has(.product__media-wrapper) .price__regular .price-item--regular');
                if (regPriceEl) {
                  // If there's no compare-at price, this is the main price
                  if (!formattedComparePrice) {
                    regPriceEl.textContent = formattedPrice;
                  }
                }
              } catch (e) {
                console.error('Error updating prices on load:', e);
              }
            }
          }
          
          // Add "From" prefix
          this.updatePriceWithFromPrefix();

           // 🆕 ADD THIS: Strip currency codes on page load
          const priceItems = this.querySelectorAll('.product:has(.product__media-wrapper) .price-item--regular, .product:has(.product__media-wrapper) .price-item--sale');
          priceItems.forEach(priceItem => {
            let priceText = priceItem.textContent.trim();
            // Remove currency code letters before the $ symbol
            priceText = priceText.replace(/[A-Z]{1,3}\$/, '$');
            priceItem.textContent = priceText;
          });
          
        }, 1000);
        
        // Add size change listener with multiple attempts
        const addSizeListener = () => {
          const sizeSelect = Array.from(this.querySelectorAll('select')).find(s => 
            window.lyIsOption(s, 'size')
          );
          
          if (sizeSelect && !sizeSelect.dataset.listenerAdded) {
            sizeSelect.dataset.listenerAdded = 'true';
            
            // Listen to both input and change events
            ['input', 'change'].forEach(eventType => {
              sizeSelect.addEventListener(eventType, (e) => {
                this.dataset.sizeJustChanged = 'true';
                this.dataset.lastSelectedSize = this.dataset.currentSelectedSize || '';
                
                // Wait for variant to update, THEN update price
                setTimeout(() => {
                  const variantSelects = this.querySelector('variant-selects');
                  if (variantSelects && variantSelects.currentVariant) {
                    const variantId = variantSelects.currentVariant.id;
                    
                    // Fetch updated price from server
                    const sectionId = this.dataset.section;
                    fetch(`${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`)
                      .then(response => response.text())
                      .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');
                        const newPrice = doc.querySelector('.price');
                        const currentPrice = this.querySelector('.price');
                        
                        if (newPrice && currentPrice) {
                          currentPrice.innerHTML = newPrice.innerHTML;
                          
                          // 🆕 Strip currency codes (CA, A, NZ, etc.) from all price items
                          const priceItems = currentPrice.querySelectorAll('.product:has(.product__media-wrapper) .price-item--regular, .product:has(.product__media-wrapper) .price-item--sale');
                          
                          priceItems.forEach(priceItem => {
                            let priceText = priceItem.textContent.trim();
                            // Remove currency code letters before the $ symbol
                            priceText = priceText.replace(/[A-Z]{1,3}\$/, '$');
                            priceItem.textContent = priceText;
                          });
                        }
                      })
                      .catch(err => console.error('Price update failed:', err));
                  }
                }, 100);
              }, true);
            });
          } 
        };
        
        // Try immediately and after delays
        addSizeListener();
        setTimeout(addSizeListener, 100);
        setTimeout(addSizeListener, 500);

        // Listen for color changes to detect product swaps (with retries)
        const addColorListener = () => {
          const colorInputs = Array.from(this.querySelectorAll('input')).filter(i => 
            window.lyIsOption(i, 'colour')
          );          
          
          if (colorInputs.length > 0) {
            colorInputs.forEach(input => {
              if (!input.dataset.swapListenerAdded) {
                input.dataset.swapListenerAdded = 'true';
                input.addEventListener('change', (e) => {
                  // Store the current color before swap
                  const currentColorInput = Array.from(colorInputs).find(inp => inp.checked && inp !== e.target);
                  if (currentColorInput) {
                    this.selectedColorBeforeSwap = currentColorInput.value;
                  } else {
                    // First load or no previous color - still mark as swap
                    this.selectedColorBeforeSwap = 'initial';
                  }
                });
              }
            });
          } 
        };

        // Try multiple times
        addColorListener();
        setTimeout(addColorListener, 100);
        setTimeout(addColorListener, 500);    
      };

      connectedCallback() {
        // Add size change listener with multiple strategies
        const addSizeListener = () => {
          const sizeSelect = Array.from(this.querySelectorAll('select')).find(s => 
            window.lyIsOption(s, 'size')
          );
          
          const variantSelects = this.querySelector('variant-selects');
          
          if (sizeSelect && !sizeSelect.dataset.listenerAdded) {
            sizeSelect.dataset.listenerAdded = 'true';
            
            // Strategy 1: Direct listener on select
            sizeSelect.addEventListener('change', (e) => {
              this.dataset.sizeJustChanged = 'true';
              this.dataset.lastSelectedSize = this.dataset.currentSelectedSize || '';
            });
          }
          
          // Strategy 2: Listen on variant-selects element
          if (variantSelects && !variantSelects.dataset.listenerAdded) {
            variantSelects.dataset.listenerAdded = 'true';
            
            variantSelects.addEventListener('change', (e) => {
              if (e.target.name && window.lyIsOption(e.target, 'size')) {
                this.dataset.sizeJustChanged = 'true';
                this.dataset.lastSelectedSize = this.dataset.currentSelectedSize || '';
              }
            }, true);
          }
        };
        
        addSizeListener();
        setTimeout(addSizeListener, 200);
        setTimeout(addSizeListener, 500);
  
        // ... rest of existing connectedCallback code
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      setMinimumPrice() {
        const variantDataScript = document.querySelector('script[data-product-variants]');
        if (!variantDataScript) return;
        
        try {
          const allVariants = JSON.parse(variantDataScript.textContent);
          const prices = allVariants.map(v => parseFloat(v.price)).filter(p => p > 0);
          const compareAtPrices = allVariants.map(v => parseFloat(v.compare_at_price)).filter(p => p > 0);
          
          const minPrice = Math.min(...prices);
          const minCompareAtPrice = compareAtPrices.length > 0 ? Math.min(...compareAtPrices) : null;
          
          const shopCurrency = window.Shopify?.currency?.active || 'GBP';

          const formattedPrice = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: shopCurrency
          }).format(minPrice / 100);
          
          const formattedComparePrice = minCompareAtPrice ? new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: shopCurrency
          }).format(minCompareAtPrice / 100) : null;
          
          // Update the price display
          const priceContainer = this.querySelector('.product:has(.product__media-wrapper) .price');
          if (!priceContainer) {
            console.log('  ❌ No price container found');
            return;
          }
          
          if (formattedComparePrice) {
            // Has sale price
            const regularPriceEl = this.querySelector('.product:has(.product__media-wrapper) .price-item--regular');
            const salePriceEl = this.querySelector('.product:has(.product__media-wrapper) .price-item--sale');
            
            if (regularPriceEl) regularPriceEl.textContent = formattedComparePrice;
            if (salePriceEl) salePriceEl.textContent = formattedPrice;
            
            priceContainer.classList.add('price--on-sale');
          } else {
            // Regular price only
            const regularPriceEl = this.querySelector('.product:has(.product__media-wrapper) .price-item--regular');
            if (regularPriceEl) regularPriceEl.textContent = formattedPrice;
          }
          
        } catch (e) {
          console.error('Error setting minimum price:', e);
        }
      }

      updatePriceWithFromPrefix() {
        const variantDataScript = document.querySelector('script[data-product-variants]');
        if (!variantDataScript) return;
        
        try {
          const allVariants = JSON.parse(variantDataScript.textContent);
          const prices = allVariants.map(v => parseFloat(v.price)).filter(p => p > 0);
          const minPrice = Math.min(...prices);
          const maxPrice = Math.max(...prices);
          const hasVariablePricing = minPrice !== maxPrice;
          
          if (hasVariablePricing) {
            const priceContainer = this.querySelector('.product:has(.product__media-wrapper) .price');
            const isOnSale = priceContainer?.classList.contains('price--on-sale');
            
            if (isOnSale) {
              const salePrice = this.querySelector('.product:has(.product__media-wrapper) .price-item--sale');
              if (salePrice) {
                const currentText = salePrice.textContent.trim();
                if (!currentText.startsWith(window.lyT('priceFrom', 'From [price]').split('[price]')[0])) {
                  salePrice.textContent = window.lyT('priceFrom', 'From [price]', { price: currentText });
                }
              }
            } else {
              const priceItems = this.querySelectorAll('.product:has(.product__media-wrapper) .price-item--regular');
              priceItems.forEach(priceItem => {
                const currentText = priceItem.textContent.trim();
                if (!currentText.startsWith(window.lyT('priceFrom', 'From [price]').split('[price]')[0])) {
                  priceItem.textContent = window.lyT('priceFrom', 'From [price]', { price: currentText });
                }
              });
            }
          }
        } catch (e) {
          console.error('Error updating price prefix:', e);
        }
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
          publish(PUB_SUB_EVENTS.sectionRefreshed, {
            data: {
              sectionId: this.sectionId,
              resource: {
                type: SECTION_REFRESH_RESOURCE_TYPE.product,
                id: newNode.dataset.productId,
              },
            },
          });
        });
        
        this.postProcessHtmlCallbacks.push((newNode) => {
          setTimeout(() => {
            const sizeSelect = Array.from(newNode.querySelectorAll('select')).find(s => 
              window.lyIsOption(s, 'size')
            );
            if (sizeSelect) {
              sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
            
            // Final authoritative button state check after all other code has run
            setTimeout(() => {
              const btn = newNode.querySelector('button[name="add"]');
              const variantSelects = newNode.querySelector('variant-selects');
              const currentVariant = variantSelects?.currentVariant;
              
              // Find any size/option select and check it has a real value selected
              const optionSelects = newNode.querySelectorAll('select[name^="options["]');
              const allOptionsSelected = Array.from(optionSelects).every(s => s.value !== '');
              
              if (currentVariant?.available && allOptionsSelected && btn) {
                btn.disabled = false;
                btn.classList.remove('disabled');
                const span = btn.querySelector('span');
                if (span) span.textContent = window.lyT('addToBasket', 'Add to basket');
              }
            }, 400);
            
          }, 150);
        });        
      }
      
      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
      
        // Patch undefined positions in selectedOptionValues - combined listings don't track standard select options
        if (selectedOptionValues.includes(undefined)) {
          const sizeSelect = Array.from(this.querySelectorAll('select')).find(s => 
            window.lyIsOption(s, 'size')
          );
          selectedOptionValues.forEach((val, index) => {
            if (val === undefined && sizeSelect?.value) {
              selectedOptionValues[index] = sizeSelect.value;
            }
          });
        }
      
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
      
        // A/B Test: New behavior - skip HTML fetch for same product
        if (ENABLE_NEW_VARIANT_SELECTION && !shouldSwapProduct) {
          
          const variantSelects = this.querySelector('variant-selects');
          
          // NEW: Update variant option button states (MOVED OUTSIDE currentVariant check)
          const updateVariantOptionStates = () => {
            setTimeout(() => {
              
              // Get variant data from the script tag
              const variantDataScript = document.querySelector('script[data-product-variants]');
              if (!variantDataScript) {
                console.log('No variant data script found');
                return;
              }
              
              let allVariants = window.LYAllVariants || [];
              if (!allVariants.length) {
                try {
                  allVariants = JSON.parse(variantDataScript.textContent);
                } catch (e) {
                  console.error('Error parsing variant data:', e);
                  return;
                }
              }
              
              // Get currently selected color (if exists)
              const colorInputs = Array.from(this.querySelectorAll('input:checked')).filter(i => 
                window.lyIsOption(i, 'colour')
              );
              
              const selectedColor = colorInputs.length > 0 ? colorInputs[0].value : null;
              
              // Get currently selected size - read DIRECTLY from the size dropdown
              const sizeSelect = Array.from(this.querySelectorAll('select')).find(s => 
                window.lyIsOption(s, 'size')
              );
              const sizeButton = Array.from(this.querySelectorAll('input:checked')).find(i => 
                window.lyIsOption(i, 'size')
              );

              let selectedSize = null;

              if (sizeSelect) {
                // For dropdown, get the selected option's value
                selectedSize = sizeSelect.options[sizeSelect.selectedIndex]?.value;
              } else if (sizeButton) {
                selectedSize = sizeButton.value;
              }
              
              // UPDATE SIZE BUTTONS (if they exist and are buttons, not dropdown)
              const sizeButtonInputs = Array.from(this.querySelectorAll('input[type="radio"]')).filter(i => 
                window.lyIsOption(i, 'size')
              );
              
              if (sizeButtonInputs.length > 0) {
                
                sizeButtonInputs.forEach(input => {
                  const sizeValue = input.value;
                  
                  // Find ALL variants that match this size (ignore fit and color)
                  const matchingVariants = allVariants.filter(v => {
                    // Check if ANY option matches this size value
                    const sizeMatches = v.option1 === sizeValue || 
                                      v.option2 === sizeValue || 
                                      v.option3 === sizeValue;
                    
                    return sizeMatches;
                  });
                  
                  // A size is available if ANY variant for that size is in stock
                  // (regardless of fit or color)
                  const isAvailable = matchingVariants.some(v => v.available);
                  const label = this.querySelector(`label[for="${input.id}"]`);
                  
                  if (isAvailable) {
                    input.classList.remove('disabled');
                    if (label) label.classList.remove('ly-variants__label-disabled');
                  } else {
                    input.classList.add('disabled');
                    if (label) label.classList.add('ly-variants__label-disabled');
                  }
                });
              }

              // UPDATE SIZE DROPDOWN OPTIONS (if dropdowns exist instead of buttons)
              const sizeDropdowns = Array.from(this.querySelectorAll('select')).filter(s => 
                window.lyIsOption(s, 'size')
              );

              // Get currently selected fit (if any) - shared across all dropdowns
              const selectedFitInput = Array.from(this.querySelectorAll('input[type="radio"]'))
                .filter(input => window.lyIsOption(input, 'fit'))
                .find(input => input.checked);
              const selectedFit = selectedFitInput?.value || '';

              sizeDropdowns.forEach(sizeDropdown => {
                if (!sizeDropdown.options.length) return;

                // Identify which option position (option1/2/3) this dropdown represents
                // by matching a sample value from it against the variant data
                const dropdownOptionName = sizeDropdown.name.slice(8, -1); // strips 'options[' and ']'
                const productOptionNames = window.LYProductOptionNames || [];
                let optionIndex = productOptionNames.findIndex(name => 
                  name.toLowerCase() === dropdownOptionName.toLowerCase()
                );
                if (optionIndex === -1) optionIndex = sizeDropdowns.indexOf(sizeDropdown);
                const optionKey = `option${optionIndex + 1}`;
                if (optionIndex === -1) return;

                Array.from(sizeDropdown.options).forEach(option => {
                  if (!option.value) return; // skip placeholder

                  const sizeValue = option.value;

                  console.log('selectedColor:', selectedColor, 'optionKey:', optionKey, 'sizeValue:', sizeValue);

                  // Only match variants where THIS option position equals this size value
                  const matchingVariants = allVariants.filter(v => {
                    if (v[optionKey] !== sizeValue) return false;
                    if (selectedColor) {
                      const colorMatches = v.option1 === selectedColor || 
                                          v.option2 === selectedColor || 
                                          v.option3 === selectedColor;
                      if (!colorMatches) return false;
                    }
                    if (selectedFit) {
                      const fitMatches = v.option1 === selectedFit || 
                                        v.option2 === selectedFit || 
                                        v.option3 === selectedFit;
                      if (!fitMatches) return false;
                    }
                    return true;
                  });

                  const isAvailableInSelectedFit = matchingVariants.some(v => v.available);

                  const matchingVariantsAnyFit = allVariants.filter(v => {
                    if (v[optionKey] !== sizeValue) return false;
                    if (selectedColor) {
                      const colorMatches = v.option1 === selectedColor || v.option2 === selectedColor || v.option3 === selectedColor;
                      if (!colorMatches) return false;
                    }
                    return true;
                  });

                  console.log('matchingVariantsAnyFit:', matchingVariantsAnyFit.map(v => ({ title: v.title, available: v.available })));

                  const isAvailableInAnyFit = matchingVariantsAnyFit.some(v => v.available);
                  const sizeExistsAsVariant = allVariants.some(v => v[optionKey] === sizeValue);

                  if (!sizeExistsAsVariant) {
                    option.textContent = window.lyT('valueUnavailable', '[value] - Unavailable', { value: sizeValue });
                    option.disabled = false;
                  } else if (isAvailableInSelectedFit) {
                    option.textContent = sizeValue;
                    option.disabled = false;
                  } else if (selectedFit && isAvailableInAnyFit) {
                    const fitVariantExists = allVariants.some(v =>
                      v[optionKey] === sizeValue &&
                      (v.option1 === selectedFit || v.option2 === selectedFit || v.option3 === selectedFit)
                    );
                    option.textContent = fitVariantExists ? window.lyT('valueSoldOutIn', '[value] - Sold out in [option]', { value: sizeValue, option: selectedFit }) : window.lyT('valueUnavailableIn', '[value] - Unavailable in [option]', { value: sizeValue, option: selectedFit });
                    option.disabled = false;
                  } else if (!isAvailableInAnyFit) {
                    option.textContent = window.lyT('valueSoldOut', '[value] - Sold out', { value: sizeValue });
                    option.disabled = false;
                  } else {
                    option.textContent = sizeValue;
                    option.disabled = false;
                  }
                });
              });


              // UPDATE FIT BUTTONS (if they exist)
              const fitInputs = Array.from(document.querySelectorAll('input[type="radio"]')).filter(input => 
                window.lyIsOption(input, 'fit')
              );

              fitInputs.forEach((input, i) => {
                console.log(`  Fit ${i}: value=${input.value}, checked=${input.checked}`);
              });

              if (fitInputs.length > 0) {
                
                // Check if this update was triggered by a SIZE change (not a fit click)
                const lastSelectedSize = this.dataset.lastSelectedSize || '';
                const isSizeChange = this.dataset.sizeJustChanged === 'true';

                // Clear the flag after checking
                this.dataset.sizeJustChanged = 'false';
                
                // Store current size for next comparison
                this.dataset.lastSelectedSize = selectedSize;
                
                let hasVisibleSelectedFit = false;
                let regFitAvailable = null;
                let firstAvailableFit = null;
                
                fitInputs.forEach(input => {
                  const fitValue = input.value;
                  
                  // Check if this fit exists for ANY size on the product (not just current size)
                  const existsForAnySize = allVariants.some(v => {
                    const fitMatches = v.option1 === fitValue || 
                                      v.option2 === fitValue || 
                                      v.option3 === fitValue;
                    
                    // If color is selected, also match color
                    if (selectedColor) {
                      const colorMatches = v.option1 === selectedColor || 
                                          v.option2 === selectedColor || 
                                          v.option3 === selectedColor;
                      if (!colorMatches) return false;
                    }
                    
                    return fitMatches;
                  });
                  
                  // Find variants that match the current size and this fit value
                  const matchingVariantsThisSize = allVariants.filter(v => {
                    // Check if ANY option matches the selected size
                    const sizeMatches = !selectedSize || 
                                      v.option1 === selectedSize || 
                                      v.option2 === selectedSize || 
                                      v.option3 === selectedSize;
                    
                    if (!sizeMatches) return false;
                    
                    // Check if ANY option matches this fit value
                    const fitMatches = v.option1 === fitValue || 
                                      v.option2 === fitValue || 
                                      v.option3 === fitValue;
                    
                    if (!fitMatches) return false;
                    
                    // If color is selected, also match color
                    if (selectedColor) {
                      const colorMatches = v.option1 === selectedColor || 
                                          v.option2 === selectedColor || 
                                          v.option3 === selectedColor;
                      if (!colorMatches) return false;
                    }
                    
                    return true;
                  });
                  
                  const label = this.querySelector(`label[for="${input.id}"]`);
                  
                  // ALWAYS SHOW if fit exists for any size on the product
                  if (!existsForAnySize) {
                    input.style.display = 'none';
                    if (label) label.style.display = 'none';
                    
                    if (input.checked) {
                      input.checked = false;
                    }
                  } else {
                    // Always show the button
                    input.style.display = '';
                    if (label) label.style.display = '';
                    
                    // Check if available for CURRENT size
                    const isAvailableThisSize = matchingVariantsThisSize.some(v => v.available);
                    const existsForThisSize = matchingVariantsThisSize.length > 0;
                    
                    if (existsForThisSize && isAvailableThisSize) {
                      // Available for current size
                      input.classList.remove('disabled');
                      input.disabled = false;
                      if (label) label.classList.remove('ly-variants__label-disabled');
                      
                      // Track available fits for auto-select (ALWAYS, not just on size change)
                      if (fitValue.toUpperCase() === 'REG') {
                        regFitAvailable = input;
                      }
                     if (!firstAvailableFit || firstAvailableFit.classList.contains('disabled')) {
                        firstAvailableFit = input;
                      }
                    } else {
                      // Doesn't exist for current size OR sold out
                      input.classList.add('disabled');
                      input.disabled = false; // Keep clickable
                      if (label) label.classList.add('ly-variants__label-disabled');
                      
                      if (!existsForThisSize) {
                        console.log(`  ⚠️ Fit ${fitValue} doesn't exist for current size (but exists for other sizes)`);
                      } else {
                        console.log(`  ❌ Fit ${fitValue} is sold out for current size`);
                      }
                      
                      // Track sold-out/unavailable fits as fallback (ALWAYS, not just on size change)
                      if (fitValue.toUpperCase() === 'REG' && !regFitAvailable) {
                        regFitAvailable = input;
                      }
                      if (!firstAvailableFit) {
                        firstAvailableFit = input;
                      }
                    }
                  }
                  
                  // Track if the currently selected fit is visible and available
                  if (input.checked && input.style.display !== 'none' && !input.classList.contains('disabled')) {
                    hasVisibleSelectedFit = true;
                  } else if (input.checked) {
                    hasVisibleSelectedFit = false;
                  }
                });

                const selectedFitInput = Array.from(this.querySelectorAll('input[type="radio"]')).filter(input => 
                  window.lyIsOption(input, 'fit')
                ).find(input => input.checked);
                const selectedFitDisabled = selectedFitInput && selectedFitInput.classList.contains('disabled');

                // AUTO-SELECT: If size changed
                if (isSizeChange && (regFitAvailable || firstAvailableFit)) {
                  let fitToSelect = null;
                  
                  // Always prefer REG on size change if it's available (not disabled)
                  if (regFitAvailable && !regFitAvailable.classList.contains('disabled')) {
                    fitToSelect = regFitAvailable;
                  } else if (firstAvailableFit && !firstAvailableFit.classList.contains('disabled')) {
                    fitToSelect = firstAvailableFit;
                  } else {
                    // Fallback: select REG or first fit even if disabled
                    fitToSelect = regFitAvailable || firstAvailableFit;
                  }
                  
                  const currentSelected = Array.from(fitInputs).find(input => input.checked);
                  
                  // Only trigger change if we're selecting a different fit
                  if (fitToSelect && fitToSelect !== currentSelected) {
                    
                    // Uncheck all fits first
                    fitInputs.forEach(input => {
                      input.checked = false;
                    });
                    
                    // Select the preferred fit
                    fitToSelect.checked = true;
                    
                    // Trigger change event to update the variant
                    setTimeout(() => {
                      fitToSelect.dispatchEvent(new Event('change', { bubbles: true }));
                      setTimeout(() => {
                        const btn = document.querySelector('button[name="add"]');
                        const variantSelects = document.querySelector('variant-selects');
                        const currentVariant = variantSelects?.currentVariant;
                        
                        if (currentVariant && currentVariant.available) {
                          btn.classList.remove('disabled');
                        } else {
                          console.log('⚠️ Variant not available - keeping disabled class');
                        }
                      }, 200);
                    }, 100);
                  } else if (fitToSelect === currentSelected) {
                    console.log('✅ Correct fit already selected - no change needed');
                  }
                } else if (!isSizeChange) {
                  console.log('ℹ️ Fit was clicked (not size change) - respecting user choice');
                } else {
                  console.log('⚠️ No fits available to auto-select');
                }
                // 🆕 ADD THIS: If we just unchecked an invalid fit, trigger button update
                if (selectedFitDisabled && !hasVisibleSelectedFit) {
                  setTimeout(() => {
                    const productInfo = document.querySelector('product-info');
                    if (productInfo && typeof productInfo.updateAddToCartButton === 'function') {
                      productInfo.updateAddToCartButton();
                    }
                  }, 150);
                }
              }


              // Handle products WITHOUT fit options (Color + Size only)
              if (fitInputs.length === 0) {
                
                const colorInputs = Array.from(this.querySelectorAll('input')).filter(i => 
                  window.lyIsOption(i, 'colour')
                );
                
                const selectedColorInput = Array.from(colorInputs).find(input => input.checked);
                const currentColor = selectedColorInput?.value || '';
                
                // Check if this was a product swap (color change)
                const wasProductSwap = this.selectedColorBeforeSwap && this.selectedColorBeforeSwap !== currentColor;
                
                if (wasProductSwap) {
                  
                  // Clear the flag
                  this.selectedColorBeforeSwap = null;
                  
                  const sizeSelect = Array.from(this.querySelectorAll('select')).find(s => 
                    window.lyIsOption(s, 'size')
                  );
                  
                  const selectedSize = sizeSelect?.value;
                  
                  // If no size selected OR current size unavailable, select first available
                  if (allVariants) {
                    let needsNewSize = false;
                    
                    if (!selectedSize || selectedSize === '') {
                      needsNewSize = true;
                    } else {
                      // Check if current size is available
                      const currentSizeAvailable = allVariants.some(v => v.available && (v.option1 === selectedSize || v.option2 === selectedSize));
                      
                      if (!currentSizeAvailable) {
                        needsNewSize = true;
                      }
                    }
                    
                    if (needsNewSize) {
                      const sizeOptions = Array.from(sizeSelect.options);
                      
                      for (const option of sizeOptions) {
                        const sizeValue = option.value;
                        if (!sizeValue) continue; // Skip placeholder
                        
                        const isAvailable = allVariants.some(v => v.available && (v.option1 === sizeValue || v.option2 === sizeValue));
                        
                        if (isAvailable) {
                          sizeSelect.value = sizeValue;
                          sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                          break;
                        }
                      }
                    }
                  }
                }
              }

              // Store current size for next comparison
              this.dataset.currentSelectedSize = selectedSize;

              }, 150);

          };

          // Call the function ALWAYS (even if currentVariant is null)
          updateVariantOptionStates();

          // NOW check if currentVariant exists for the rest of the logic
          if (variantSelects && variantSelects.currentVariant) {
            const variant = variantSelects.currentVariant;
            
            // All your variant update code here...
            const form = this.querySelector('form[action$="/cart/add"][data-type="add-to-cart-form"]');
            const variantIdInput = form?.querySelector('input[name="id"]');
            
            if (variantIdInput) {
              variantIdInput.value = variant.id;
              variantIdInput.setAttribute('value', variant.id);
            }

            // Update inventory display
            const inventoryElement = this.querySelector('[id*="Inventory"]');
            if (inventoryElement) {
              const inventoryQty = variant.inventory_quantity || 0;
              
              if (inventoryQty > 0 && inventoryQty <= 25 && variant.inventory_management === 'shopify') {
                inventoryElement.innerHTML = `
                  <svg width="15" height="15" aria-hidden="true">
                    <circle cx="7.5" cy="7.5" r="7.5" fill="rgb(238,148,65, 0.3)"/>
                    <circle cx="7.5" cy="7.5" r="5" stroke="rgb(255, 255, 255)" stroke-width="1" fill="rgb(238,148,65)"/>
                  </svg>
                  Low stock: ${inventoryQty} left
                `;
                inventoryElement.classList.remove('visibility-hidden');
                inventoryElement.style.display = 'block';
              } else {
                inventoryElement.innerHTML = '';
                inventoryElement.classList.remove('visibility-hidden');
                inventoryElement.style.display = 'none';
              }
            }

            // Update button state
            const submitButton = form?.querySelector('[name="add"]');
            if (submitButton) {
              const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
              if (errorWrapper) {
                errorWrapper.style.display = 'none';
              }
              
              // For multi-size-dropdown products, check the exact combination availability
              const allSizeDropdowns = Array.from(this.querySelectorAll('select')).filter(s => 
                window.lyIsOption(s, 'size') && s.name.startsWith('options[')
              );

              let effectivelyAvailable;

              if (allSizeDropdowns.length > 1) {
                const selectedValues = allSizeDropdowns.map(s => s.value);
                const allOptionsChosen = selectedValues.every(v => v && v !== '');
                if (!allOptionsChosen) {
                  effectivelyAvailable = false;
                } else {
                  const variantDataScript = document.querySelector('script[data-product-variants]');
                  let allVariants = window.LYAllVariants || [];
                  if (!allVariants.length) {
                    const firstDropdown = allSizeDropdowns[0];
                    setTimeout(() => firstDropdown?.dispatchEvent(new Event('change', { bubbles: true })), 200);
                    return;
                  }
                  const matchingVariant = allVariants.find(v => 
                    selectedValues.every((val, i) => v[`option${i + 1}`] === val)
                  );
                  console.log('Matching variant from data script:', matchingVariant?.id, 'available:', matchingVariant?.available);
                  console.log('All variants availability:', allVariants.map(v => ({ title: v.title, available: v.available })));
                  effectivelyAvailable = !!matchingVariant && matchingVariant.available;
                }
              } else {
                effectivelyAvailable = variant.available;
              }

              if (effectivelyAvailable) {
                submitButton.style.display = '';
                submitButton.disabled = false;
                const buttonText = submitButton.querySelector('span');
                if (buttonText) {
                  buttonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
                }
                const shopPayButton = document.querySelector('.product:has(.product__media-wrapper) .shopify-payment-button');
                if (shopPayButton) shopPayButton.style.display = '';
                
                const soldOutBadge = document.querySelector('.product:has(.product__media-wrapper) .price__badge-sold-out');
                const priceContainer = document.querySelector('.product:has(.product__media-wrapper) .price');
                if (soldOutBadge) soldOutBadge.style.display = 'none';
                if (priceContainer) priceContainer.classList.remove('price--sold-out');
                
                const swymButton = document.querySelector('swymcs-watchlist-button');
                const swymNotifyButton = swymButton?.querySelector('.swymcs-notify-button');
                if (swymButton) {
                  swymButton.setAttribute('available', 'true');
                  swymButton.setAttribute('variant-id', variant.id);
                }
                if (swymNotifyButton) {
                  swymNotifyButton.classList.add('swym-hide-button');
                }
                
                // Flicker fix: this block used to be repeated wholesale in a 250ms
                // timeout, giving the badge a second, later write. The only thing
                // unique to that repeat was the section stock class, so it runs here.
                const mainProductSection = document.querySelector('.MainProductSection');
                if (mainProductSection) {
                  mainProductSection.classList.add('landy-in-stock');
                  mainProductSection.classList.remove('landy-out-of-stock');
                }
              } else {
                submitButton.style.display = 'none';
                const shopPayButton = document.querySelector('.product:has(.product__media-wrapper) .shopify-payment-button');
                if (shopPayButton) shopPayButton.style.display = 'none';
                                
                const soldOutBadge = document.querySelector('.product:has(.product__media-wrapper) .price__badge-sold-out');
                const priceContainer = document.querySelector('.product:has(.product__media-wrapper) .price');
                if (soldOutBadge) soldOutBadge.style.display = '';
                if (priceContainer) priceContainer.classList.add('price--sold-out');
                
                const swymButton = document.querySelector('swymcs-watchlist-button');
                const swymNotifyButton = swymButton?.querySelector('.swymcs-notify-button');
                if (swymButton) {
                  swymButton.setAttribute('available', 'false');
                  swymButton.setAttribute('variant-id', variant.id);
                }
                if (swymNotifyButton) {
                  swymNotifyButton.classList.remove('swym-hide-button');
                }
                
                // Flicker fix: the 250ms repeat of this block was removed. Its section
                // stock class runs here; only the similar-variant modal check still
                // needs to wait for the DOM to settle.
                const mainProductSection = document.querySelector('.MainProductSection');
                if (mainProductSection) {
                  mainProductSection.classList.add('landy-out-of-stock');
                  mainProductSection.classList.remove('landy-in-stock');
                }

                setTimeout(() => {
                  try {
                    const productOptionNames = window.LYProductOptionNames || [];
                    window.LYCheckSimilarVariant(variant, productOptionNames);
                  } catch (e) {
                    console.error('Similar variant modal check failed:', e);
                  }
                }, 250);
              }
            }

            
            // Update URL
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          } else {
            
            // Get variant data to find a price
            const variantDataScript = document.querySelector('script[data-product-variants]');
            let priceToShow = null;
            
            if (variantDataScript) {
              try {
                const allVariants = JSON.parse(variantDataScript.textContent);
                
                // Try to get price from first available variant
                const firstAvailable = allVariants.find(v => v.available);
                
                if (firstAvailable) {
                  priceToShow = firstAvailable.price;
                } else if (allVariants.length > 0) {
                  // All sold out - use first variant's price
                  priceToShow = allVariants[0].price;
                }
              } catch (e) {
                console.error('Error getting variant price:', e);
              }
            }
            
            // No valid variant exists - show sold out state
            const form = this.querySelector('form[action$="/cart/add"][data-type="add-to-cart-form"]');
            const submitButton = form?.querySelector('[name="add"]');
            
            if (submitButton) {

              const productCategory = document.querySelector('[data-product-category]')?.dataset.productCategory || '';
              const isGiftCard = productCategory === 'gift cards';
            
              // Force show variant picker fieldsets for gift card products
              if (isGiftCard) {
                document.querySelectorAll('variant-selects .product-form__input').forEach(el => {
                  el.classList.remove('js');
                });
              }
            
              const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
              if (errorWrapper) {
                errorWrapper.style.display = 'none';
              }
              
              // Check if selection is complete before showing "Unavailable"
              const sizeSelects = Array.from(this.querySelectorAll('select')).filter(s => 
                window.lyIsOption(s, 'size')
              );
              const sizeSelect = sizeSelects[0];

              const fitInputs = Array.from(this.querySelectorAll('input[type="radio"]')).filter(input => 
                window.lyIsOption(input, 'fit')
              );
              const allSizesSelected = sizeSelects.length > 0 && sizeSelects.every(s => s.value && s.value !== '');
              const selectedSize = sizeSelect?.value;
              const hasRealSize = selectedSize && selectedSize !== '';

              // Get selected fit input and its value
              const selectedFitInput = Array.from(fitInputs).find(input => input.checked);
              const selectedFit = selectedFitInput?.value || '';

              const hasFitOption = fitInputs.length > 0;
              const isComplete = allSizesSelected && (!hasFitOption || selectedFit);
              
              // Check if variant exists and is available
              const variantSelects = document.querySelector('variant-selects');
              const currentVariant = variantSelects?.currentVariant;
            
              if (!isGiftCard) {
                  const isMultiDropdown = sizeSelects.length > 1;
                  if (isComplete && !isMultiDropdown && (!currentVariant || !currentVariant.available)) {
                  submitButton.style.display = '';
                  submitButton.disabled = true;
                  const buttonText = submitButton.querySelector('span');
                  if (buttonText) {
                    buttonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
                  }
                  const shopPayButton = document.querySelector('.product:has(.product__media-wrapper) .shopify-payment-button');
                  if (shopPayButton) shopPayButton.style.display = 'none';
                  
                  // Update sold-out badges and styling
                  const soldOutBadge = document.querySelector('.product:has(.product__media-wrapper) .price__badge-sold-out');
                  const priceContainer = document.querySelector('.product:has(.product__media-wrapper) .price');
                  if (soldOutBadge) soldOutBadge.style.display = '';
                  if (priceContainer) priceContainer.classList.add('price--sold-out');
                  
                  // Hide Swym "Notify Me" button when unavailable (doesn't exist)
                  const swymButton = document.querySelector('swymcs-watchlist-button');
                  const swymNotifyButton = swymButton?.querySelector('.swymcs-notify-button');
                  if (swymButton) swymButton.setAttribute('available', 'false');
                  if (swymNotifyButton) swymNotifyButton.classList.add('swym-hide-button');
                  
                  // Flicker fix: the 250ms repeat of this block was removed. Its section
                  // stock class runs here; the price update still has to wait, or the
                  // section render overwrites it.
                  const mainProductSection = document.querySelector('.MainProductSection');
                  if (mainProductSection) {
                    mainProductSection.classList.add('landy-out-of-stock');
                    mainProductSection.classList.remove('landy-in-stock');
                  }

                  setTimeout(() => {
                    if (priceToShow) {
                      const priceElement = document.querySelector('.product:has(.product__media-wrapper) .price-item--regular .money, .product:has(.product__media-wrapper) .price-item--sale .money');
                      if (priceElement) {
                        const shopCurrency = window.Shopify?.currency?.active || 'GBP';
                        const formattedPrice = new Intl.NumberFormat('en-GB', {
                          style: 'currency',
                          currency: shopCurrency
                        }).format(priceToShow / 100);
                        priceElement.textContent = formattedPrice;
                      }
                    }
                  }, 250);
                } else if (isComplete && currentVariant && currentVariant.available) {
                  // Variant is available - let updateAddToCartButton handle it
                  return;
                } else {
                  // Selection incomplete - keep button as "Select options"
                  submitButton.style.display = '';
                  submitButton.disabled = true;
                  const buttonText = submitButton.querySelector('span');
                  if (buttonText) {
                    buttonText.textContent = window.lyT('selectOptions', 'Select options');
                  }
                  const shopPayButton = document.querySelector('.product:has(.product__media-wrapper) .shopify-payment-button');
                  if (shopPayButton) shopPayButton.style.display = '';
                }
              }
            }
            
            
            // Hide inventory display
            const inventoryElement = this.querySelector('[id*="Inventory"]');
            if (inventoryElement) {
              inventoryElement.innerHTML = '';
              inventoryElement.style.display = 'none';
            }
          }
          return; // Exit early - don't fetch HTML
        }

        // Store the selected size before product swap
        if (shouldSwapProduct) {
          const sizeSelect = Array.from(this.querySelectorAll('select')).find(s => 
            window.lyIsOption(s, 'size')
          );
          
          this.selectedSizeBeforeSwap = sizeSelect?.value;
  
          // Store color before swap
          const colorInputs = Array.from(this.querySelectorAll('input')).filter(i => 
            window.lyIsOption(i, 'colour')
          );
          
          const selectedColorInput = Array.from(colorInputs).find(input => input.checked);
          this.selectedColorBeforeSwap = selectedColorInput?.value || '';

          // Warm the target product's variants so the pre-paint correction in
          // handleSwapProduct has them by the time the section HTML lands.
          try {
            window.LYVariantsFor(productUrl);
          } catch (e) {}
        }

        this.resetProductFormState();
      
        const shouldFetchFullPage = !this.isFeaturedProduct && shouldSwapProduct;
      
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct ? this.handleSwapProduct(productUrl) : this.handleUpdateProductInfo(productUrl),
        });
      }
      

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      get isFeaturedProduct() {
        return this.dataset.section.includes('featured_product');
      }

      handleSwapProduct(productUrl) {
        return (html) => {
          this.productModal?.remove();
      
          // Grab the selected variant from the new product info
          const variant = this.getSelectedVariant(html.querySelector(`product-info[data-section=${this.sectionId}]`));
          this.updateURL(productUrl, variant?.id);
      
          // Hide buttons in incoming HTML before swap so intermediate state is never visible
          const incomingButtons = html.querySelector('.product-form__buttons');
          if (incomingButtons) incomingButtons.style.visibility = 'hidden';

          // Same idea for the selection itself: the incoming HTML is rendered with
          // this product's defaults, often a sold-out variant. Point it at a real
          // one before it is painted so there is no wrong state to correct later.
          //
          // If that succeeds the buttons no longer need hiding - the incoming state
          // is already correct. Leaving them hidden is what produced the ~1.5s gap
          // where a shopper saw neither "Add to basket" nor "Notify me" at all.
          try {
            const preselected = window.LYPreselectIncoming(html, productUrl, this.selectedSizeBeforeSwap);
            if (preselected && incomingButtons) incomingButtons.style.visibility = '';
          } catch (e) {
            console.error('Preselect on swap failed:', e);
          }
      
          // If we are in an embedded context (quick add, featured product, etc), only swap product info.
          // Otherwise, refresh the entire page content and sibling sections.
          if (this.dataset.updateUrl === 'false') {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
      
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
      
          // AFTER SWAP: Fix empty price container
          setTimeout(() => {
      
            // Check if price container is empty
            const priceContainer = document.querySelector('.product:has(.product__media-wrapper) .price-container');
      
            if (priceContainer && priceContainer.innerHTML.trim() === '') {
      
              // Get the price container from the fetched HTML
              const fetchedPriceContainer = html.querySelector('.product:has(.product__media-wrapper) .price-container');
      
              if (fetchedPriceContainer && fetchedPriceContainer.innerHTML.trim() !== '') {
                priceContainer.innerHTML = fetchedPriceContainer.innerHTML;
              } else {
      
                // Manually build price HTML with MINIMUM prices
                const variantDataScript = document.querySelector('script[data-product-variants]');
                if (variantDataScript) {
                  try {
                    const allVariants = JSON.parse(variantDataScript.textContent);
      
                    const prices = allVariants.map(v => parseFloat(v.price)).filter(p => p > 0);
                    const compareAtPrices = allVariants.map(v => parseFloat(v.compare_at_price)).filter(p => p > 0);
      
                    const minPrice = Math.min(...prices);
                    const minCompareAtPrice = compareAtPrices.length > 0 ? Math.min(...compareAtPrices) : null;
                    const maxPrice = Math.max(...prices);
                    const hasVariablePricing = minPrice !== maxPrice;
      
                    const priceToShow = minPrice;
                    const comparePrice = minCompareAtPrice;
      
                    if (priceToShow) {
                      const shopCurrency = window.Shopify?.currency?.active || 'GBP';
      
                      const formattedPrice = new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: shopCurrency
                      }).format(priceToShow / 100);
      
                      const formattedComparePrice = comparePrice ? new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: shopCurrency
                      }).format(comparePrice / 100) : null;
      
                      const pricePrefix = hasVariablePricing ? 'From ' : '';
      
                      // This rebuild replaces the whole price block, badge included. The
                      // badge's label is contextual ("Unavailable in Tall", "Sold out in
                      // Petite") and is set elsewhere, so hardcoding "Sold out" here threw
                      // it away and a later pass had to put it back - the visible flip
                      // between "Sold out" and "Unavailable in Tall" on the first click.
                      const existingBadge = priceContainer.querySelector('.price__badge-sold-out');
                      const badgeLabel = (existingBadge && existingBadge.textContent.trim()) || window.lyT('soldOut', 'Sold out');

                      let priceHTML = `
                        <div class="price price--large ${comparePrice ? 'price--on-sale' : ''}">
                          <div class="price__container">
                      `;
      
                      if (comparePrice) {
                        priceHTML += `
                            <div class="price__sale">
                              <span class="visually-hidden">${window.lyT('regularPrice', 'Regular price')}</span>
                              <span><s class="price-item price-item--regular">${formattedComparePrice}</s></span>
                              <span class="visually-hidden">${window.lyT('salePrice', 'Sale price')}</span>
                              <span class="price-item price-item--sale">${formattedPrice}</span>
                            </div>
                        `;
                      } else {
                        priceHTML += `
                            <div class="price__regular">
                              <span class="visually-hidden">${window.lyT('regularPrice', 'Regular price')}</span>
                              <span class="price-item price-item--regular">${formattedPrice}</span>
                            </div>
                        `;
                      }
      
                      priceHTML += `
                          </div>
                          <span class="badge price__badge-sold-out color-scheme-3">${badgeLabel}</span>
                        </div>
                      `;
      
                      priceContainer.innerHTML = priceHTML;
                    }
                  } catch (e) {
                    console.error('Error building price:', e);
                  }
                }
              }
            }
      
            // Handle size selection after product swap
            const newSizeSelect = Array.from(document.querySelectorAll('select')).find(s =>
              window.lyIsOption(s, 'size')
            );
      
            if (newSizeSelect) {
              const variantDataScript = document.querySelector('script[data-product-variants]');
              let allVariants = [];
              if (variantDataScript) {
                try {
                  allVariants = JSON.parse(variantDataScript.textContent);
                } catch (e) {}
              }
      
              // Check if this was a color change (product swap)
              if (this.selectedColorBeforeSwap) {
      
                const previousSize = this.selectedSizeBeforeSwap;
      
                // Clear the flags
                this.selectedColorBeforeSwap = null;
                this.selectedSizeBeforeSwap = null;
      
                // If there was a previous size, try to keep it
                if (previousSize) {
                  const previousSizeAvailable = allVariants.some(v =>
                    v.available && (v.option1 === previousSize || v.option2 === previousSize)
                  );
      
                  if (previousSizeAvailable) {
                    console.log('✅ Keeping previous size:', previousSize);
                    newSizeSelect.value = previousSize;
                    newSizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                  } else {
                    console.log('⚠️ Previous size not available - selecting first available');
                  }
                } else {
                  console.log('⚠️ No previous size - selecting first available');
                }
      
                // Find and select first available size
                const sizeOptions = Array.from(newSizeSelect.options);
                for (const option of sizeOptions) {
                  if (!option.value) continue;
      
                  const isAvailable = allVariants.some(v =>
                    v.available && (v.option1 === option.value || v.option2 === option.value)
                  );
      
                  if (isAvailable) {
                    newSizeSelect.value = option.value;
                    newSizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    break;
                  }
                }
              } else if (this.selectedSizeBeforeSwap) {
                // Not a color change, just restore previous size if available
                const previousSizeAvailable = allVariants.some(v =>
                  v.available && (v.option1 === this.selectedSizeBeforeSwap || v.option2 === this.selectedSizeBeforeSwap)
                );
      
                if (previousSizeAvailable) {
                  newSizeSelect.value = this.selectedSizeBeforeSwap;
                }
                this.selectedSizeBeforeSwap = null;
              } else {
                // No previous state - check if there's only one size option
                const sizeOptions = Array.from(newSizeSelect.options).filter(opt => opt.value);
      
                if (sizeOptions.length === 1) {
                  newSizeSelect.value = sizeOptions[0].value;
                  newSizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            }
      
            // TRIGGER VARIANT UPDATE LOGIC AFTER SWAP
            setTimeout(() => {
      
              const newProductInfo = document.querySelector('product-info');
              if (newProductInfo && ENABLE_NEW_VARIANT_SELECTION) {
                const sizeSelect = Array.from(newProductInfo.querySelectorAll('select')).find(s =>
                  window.lyIsOption(s, 'size')
                );
      
                const selectedSize = sizeSelect?.value;
      
                if (selectedSize) {
                  sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
      
              // Restore buttons after size is selected and button state is correct
              const newProductFormButtons = document.querySelector('.product:has(.product__media-wrapper) .product-form__buttons');
              if (newProductFormButtons) newProductFormButtons.style.visibility = 'visible';
      
            }, 100);
      
          }, 300);
        };
      }          

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        this.pendingRequestUrl = requestUrl;
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
      
          // PRESERVE DROPDOWN VALUES BEFORE UPDATE
          const currentDropdowns = {};
          this.querySelectorAll('select[name^="options"]').forEach(select => {
            currentDropdowns[select.name] = select.value;
          });
      
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
      
          if (!variant) {
            this.setUnavailable();
            return;
          }
      
          this.updateMedia(html, variant?.featured_media?.id);
      
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };
      
          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
      
          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');
      
          const isButtonDisabled =
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true;
          this.productForm?.toggleSubmitButton(
            isButtonDisabled,
            isButtonDisabled ? window.variantStrings.soldOut : null
          );
      
          // RESTORE DROPDOWN VALUES AFTER UPDATE
          setTimeout(() => {
            Object.keys(currentDropdowns).forEach(name => {
              const dropdown = this.querySelector(`select[name="${name}"]`);
              if (dropdown && currentDropdowns[name]) {
                dropdown.value = currentDropdowns[name];
              }
            });
          }, 0);
      
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }
      

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        if (variantFeaturedMediaId) {
          // set featured media as active in the media gallery
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );

          // update media modal
          const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
          const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
          if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

// Fix initial variant selection - run AFTER all other code
if (window.ENABLE_NEW_VARIANT_SELECTION) {

  window.LYAllVariants = null;
  const fetchAllVariants = () => {
    const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    if (!handle) return;
    
    const fetchPage = (page, accumulated) => {
      fetch(window.lyUrl(`products/${handle}.js?limit=250&page=${page}`))
        .then(r => r.json())
        .then(data => {
          const combined = accumulated.concat(data.variants);
          if (data.variants.length === 250) {
            // There might be more, fetch next page
            fetchPage(page + 1, combined);
          } else {
            window.LYAllVariants = combined;
          }
        })
        .catch(() => {
          if (accumulated.length) window.LYAllVariants = accumulated;
        });
    };
    
    fetchPage(1, []);
  };
  fetchAllVariants();
  
  const updateAddToCartButton = () => {
    
    const addToCartButton = document.querySelector('button[name="add"], button[type="submit"][form*="product-form"]');
    const sizeSelects = Array.from(document.querySelectorAll('select')).filter(s => 
      window.lyIsOption(s, 'size') && s.name.startsWith('options[')
    );
    
    const fitInputs = Array.from(document.querySelectorAll('input[type="radio"]')).filter(input => 
      window.lyIsOption(input, 'fit')
    );
    
    // Check if product has NO size or fit options
    const hasNoOptions = sizeSelects.length === 0 && fitInputs.length === 0;
    
    if (hasNoOptions) {
      // Product has no options - enable add to cart immediately
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('disabled');
      const buttonSpan = addToCartButton.querySelector('span');
      if (buttonSpan) {
        buttonSpan.textContent = window.lyT('addToBasket', 'Add to basket');
      }
      return; // Exit early
    }

    // All size dropdowns must have a real value selected
    const allSizesSelected = sizeSelects.length > 0 && sizeSelects.every(s => s.value && s.value !== '');

    // For single-dropdown products, keep selectedSize for badge/sold-out logic below
    const sizeSelect = sizeSelects[0];
    const selectedSize = sizeSelects[0]?.value;
    const hasRealSize = selectedSize && selectedSize !== '';

    // Get selected fit input and its value
    const selectedFitInput = Array.from(fitInputs).find(input => input.checked);
    const selectedFit = selectedFitInput?.value || '';

    // Check if product HAS a fit option
    const hasFitOption = fitInputs.length > 0;

    // Determine if selection is complete
    const isComplete = allSizesSelected && (!hasFitOption || selectedFit);

    // Add/remove body class to control sold out badge visibility
    if (isComplete) {
      document.body.classList.add('variant-fully-selected');
    } else {
      document.body.classList.remove('variant-fully-selected');
    }

    
    // Get current variant to check if it's actually sold out or doesn't exist
    const variantSelects = document.querySelector('variant-selects');
    const currentVariant = variantSelects?.currentVariant;

    // Handle undefined vs null - undefined means variant system hasn't initialized yet
    if (currentVariant === undefined) {
      
      // If size is selected but variant system hasn't initialized, try to find and select the variant manually
      if (hasRealSize && (!hasFitOption || selectedFit)) {
        const variantDataScript = document.querySelector('script[data-product-variants]');
        if (variantDataScript) {
          try {
            const allVariants = JSON.parse(variantDataScript.textContent);

            // Get selected color if exists
            const colorInputs = Array.from(document.querySelectorAll('input:checked')).filter(i => 
              window.lyIsOption(i, 'colour')
            );
            
            const selectedColor = colorInputs.length > 0 ? colorInputs[0].value : null;

            // Find variant matching BOTH size AND color (if color exists)
            const matchingVariant = allVariants.find(v => {
              const sizeMatches = v.option1 === selectedSize || v.option2 === selectedSize || v.option3 === selectedSize;
              
              if (selectedColor) {
                const colorMatches = v.option1 === selectedColor || v.option2 === selectedColor || v.option3 === selectedColor;
                return sizeMatches && colorMatches;
              }
              
              return sizeMatches;
            });
            
            if (matchingVariant) {
              
              // Update the variant ID input
              const variantIdInput = document.querySelector('input[name="id"]');
              if (variantIdInput) {
                variantIdInput.value = matchingVariant.id;
              }
              
              // Treat as available and continue
              const isSoldOut = !matchingVariant.available;
              
              // Hide notify me button
              const notifyMeButton = document.querySelector('swymcs-watchlist-button');
              if (notifyMeButton) {
                notifyMeButton.style.display = 'none';
              }
              
              // Hide sold out badge with !important
              if (!isSoldOut) {
                const removeSoldOutClasses = () => {
                  const soldOutBadges = document.querySelectorAll('.product:has(.product__media-wrapper) .badge.price__badge-sold-out, .product:has(.product__media-wrapper) .price__badge-sold-out, [class*="badge-sold-out"]');
                  soldOutBadges.forEach(badge => {
                    badge.style.setProperty('display', 'none', 'important');
                    badge.setAttribute('hidden', '');
                  });
                  
                  // Remove the sold-out class from price container
                  const priceContainers = document.querySelectorAll('.product:has(.product__media-wrapper) .price--sold-out');
                  priceContainers.forEach(container => {
                    container.classList.remove('price--sold-out');
                    container.classList.remove('price--show-badge');
                  });
                };
                
                // Flicker fix: was called at 0/50/150/300ms, each call re-stamping the
                // badge. One call is enough now the pending guard holds it hidden.
                removeSoldOutClasses();
                
                // Add body class AFTER removing sold-out classes
                document.body.classList.add('variant-fully-selected');
              }

              // Update button immediately
              if (!isSoldOut) {
                addToCartButton.disabled = false;
                addToCartButton.classList.remove('disabled');
                const buttonSpan = addToCartButton.querySelector('span');
                if (buttonSpan) {
                  buttonSpan.textContent = window.lyT('addToBasket', 'Add to basket');
                }
              } else {
                addToCartButton.disabled = true;
                addToCartButton.classList.add('disabled');
                const buttonSpan = addToCartButton.querySelector('span');
                if (buttonSpan) {
                  buttonSpan.textContent = window.lyT('soldOut', 'Sold out');
                }
              }
              
              return; // Exit - we handled it manually
            }

          } catch (e) {
            console.error('Error manually selecting variant:', e);
          }
        }
      }
      
      // Add max retry counter to prevent infinite loops
      if (!updateAddToCartButton.retryCount) {
        updateAddToCartButton.retryCount = 0;
      }
      updateAddToCartButton.retryCount++;
      
      if (updateAddToCartButton.retryCount > 5) {
        console.log('⚠️ Max retries reached - stopping');
        updateAddToCartButton.retryCount = 0;
        return;
      }
      
      console.log('⚠️ Will retry in 100ms (attempt', updateAddToCartButton.retryCount, 'of 5)');
      setTimeout(updateAddToCartButton, 100);
      return;
    }

    // Reset retry counter when variant is ready
    updateAddToCartButton.retryCount = 0;
    
    // For multi-size-dropdown products, find the variant matching ALL selected sizes
    let isSoldOut;

    if (sizeSelects.length > 1) {
      // Build the combined selection from all dropdowns
      const selectedValues = sizeSelects.map(s => s.value);
      console.log('Multi-dropdown check:', sizeSelects.map(s => ({ name: s.name, value: s.value })));
      console.log('Selected values:', selectedValues);
      
      let allVariants = window.LYAllVariants || [];
      if (!allVariants.length) {
        setTimeout(updateAddToCartButton, 200);
        return;
      }
      
      // Find the variant where option1, option2, option3 match the three dropdown values
      const matchingVariant = allVariants.find(v => 
        selectedValues.every((val, i) => v[`option${i + 1}`] === val)
      );
      console.log('Matching variant:', matchingVariant?.id, matchingVariant?.available);
      isSoldOut = !matchingVariant || !matchingVariant.available;
    } else {
      isSoldOut = currentVariant === null || (currentVariant && !currentVariant.available);
    }
    
    // Show/hide notify me button
    const notifyMeButton = document.querySelector('swymcs-watchlist-button');
    if (notifyMeButton) {
      if (isComplete && isSoldOut) {
        notifyMeButton.style.display = 'block';
      } else {
        notifyMeButton.style.display = 'none';
      }
    }

    // Update sold out badge text
    const soldOutBadge = document.querySelector('.product:has(.product__media-wrapper) .badge.price__badge-sold-out');
    if (soldOutBadge) {
      // Check if product is completely sold out (all variants)
      const variantDataScript = document.querySelector('script[data-product-variants]');
      let allVariants = [];
      try {
        allVariants = JSON.parse(variantDataScript.textContent);
      } catch (e) {
        console.error('❌ Failed to parse variants:', e);
      }
      
      const anyAvailable = allVariants.some(v => v.available);
      
      // Check if the SELECTED SIZE is sold out in ALL fits
      let sizeCompletelySoldOut = false;
      if (hasRealSize) {
        const variantsForThisSize = allVariants.filter(v => {
          return v.option1 === selectedSize || v.option2 === selectedSize || v.option3 === selectedSize;
        });
        sizeCompletelySoldOut = variantsForThisSize.length > 0 && variantsForThisSize.every(v => !v.available);
      }
      
      // Priority: 0. Selected size doesn't exist as a variant at all
      const selectedSizeExists = allVariants.some(v => 
        v.option1 === selectedSize || v.option2 === selectedSize || v.option3 === selectedSize
      );      

      if (!selectedSizeExists && selectedSize) {
        soldOutBadge.textContent = window.lyT('unavailable', 'Unavailable');
      } else if (!anyAvailable) {
        soldOutBadge.textContent = window.lyT('soldOut', 'Sold out');
      } else if (sizeCompletelySoldOut) {
        soldOutBadge.textContent = window.lyT('soldOut', 'Sold out');
      } else if (isSoldOut && selectedFit && isComplete) {
        const variantExists = allVariants.some(v => 
          (v.option1 === selectedSize || v.option2 === selectedSize || v.option3 === selectedSize) &&
          (v.option1 === selectedFit || v.option2 === selectedFit || v.option3 === selectedFit)
        );        
        soldOutBadge.textContent = variantExists ? window.lyT('soldOutIn', 'Sold out in [option]', { option: selectedFit }) : window.lyT('unavailableIn', 'Unavailable in [option]', { option: selectedFit });
      }
    }
    
    console.log('isComplete:', isComplete, 'isSoldOut:', isSoldOut, 'selectedValues:', sizeSelects.map(s => s.value));

    if (isComplete && !isSoldOut) {
      
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('disabled');
      
      // Force remove again after a tiny delay to override any other code
      setTimeout(() => {
        addToCartButton.classList.remove('disabled');
      }, 10);
      
      const buttonSpan = addToCartButton.querySelector('span');
      if (buttonSpan) {
        buttonSpan.textContent = window.lyT('addToBasket', 'Add to basket');
      }
    } else if (isComplete && isSoldOut) {
      addToCartButton.disabled = true;
      addToCartButton.classList.add('disabled');
      const buttonSpan = addToCartButton.querySelector('span');
      if (buttonSpan) {
        buttonSpan.textContent = window.lyT('soldOut', 'Sold out');
      }
    } else {
      addToCartButton.disabled = true;
      addToCartButton.classList.add('disabled');
      const buttonSpan = addToCartButton.querySelector('span');
      if (buttonSpan) {
        buttonSpan.textContent = window.lyT('selectOptions', 'Select options');
      }
    }
  };


  // Listen for size/fit changes (OUTSIDE fixInitialSelection)
  document.addEventListener('change', (e) => {
    const isSizeChange = e.target.tagName === 'SELECT' && window.lyIsOption(e.target, 'size');
    const isFitChange = e.target.type === 'radio' && window.lyIsOption(e.target, 'fit');
    
    if (isSizeChange || isFitChange) {
      updateAddToCartButton();
      
      // Force update again after Shopify's code runs
      setTimeout(() => {
        updateAddToCartButton();
      }, 100);
    }
  });


  const fixInitialSelection = () => {
    const fitInputs = Array.from(document.querySelectorAll('input[type="radio"]')).filter(input => 
      window.lyIsOption(input, 'fit')
    );
    if (fitInputs.length === 0) return;
    
    // Get variant data
    const variantDataScript = document.querySelector('script[data-product-variants]');
    if (!variantDataScript) return;
    
    let allVariants = window.LYAllVariants || [];
    if (!allVariants.length) {
      try {
        allVariants = JSON.parse(variantDataScript.textContent);
      } catch (e) {
        console.error('Error parsing variant data:', e);
        return;
      }
    }
    
    // Get current size
    const sizeSelects = Array.from(document.querySelectorAll('select')).filter(s => 
      window.lyIsOption(s, 'size') && s.name.startsWith('options[')
    );
    
    const selectedSize = sizeSelects[0]?.value;

    // If no size selected (placeholder), just hide non-existent fits and exit
    if (!selectedSize) {
      
      // Still hide fits that don't exist for selected color
      const colorInputs = Array.from(document.querySelectorAll('input')).filter(i => 
        window.lyIsOption(i, 'colour')
      );
      
      const selectedColorInput = Array.from(colorInputs).find(input => input.checked);
      const selectedColor = selectedColorInput?.value || '';
      
      fitInputs.forEach(input => {
        const fitValue = input.value;
        const label = input.nextElementSibling;
        
        const existsForSelectedColor = allVariants.some(v => {
          const hasFit = v.option1 === fitValue || v.option2 === fitValue || v.option3 === fitValue;
          if (selectedColor) {
            const hasColor = v.option1 === selectedColor || v.option2 === selectedColor || v.option3 === selectedColor;
            return hasFit && hasColor;
          }
          return hasFit;
        });
        
        if (!existsForSelectedColor) {
          input.classList.add('hidden');
          input.disabled = true;
          if (label) label.classList.add('hidden');
        } else {
          input.classList.remove('hidden');
          if (label) label.classList.remove('hidden');
        }
      });
      
      return; // Exit early
    }

    // DON'T auto-select any fit on page load - let user choose
    console.log('✅ No fit auto-selected on page load - waiting for user choice');

    // Uncheck all fits
    fitInputs.forEach(input => input.checked = false);
    
    // Get selected color if it exists
    const colorInputs = Array.from(document.querySelectorAll('input')).filter(i => 
      window.lyIsOption(i, 'colour')
    );
    
    const selectedColorInput = Array.from(colorInputs).find(input => input.checked);
    const selectedColor = selectedColorInput?.value || '';
    
    fitInputs.forEach(input => {
      const fitValue = input.value;
      const label = input.nextElementSibling;
      
      // Check if this fit exists for the selected color (or any color if none selected)
      const existsForSelectedColor = allVariants.some(v => {
        const hasFit = v.option1 === fitValue || v.option2 === fitValue || v.option3 === fitValue;
        
        if (selectedColor) {
          const hasColor = v.option1 === selectedColor || v.option2 === selectedColor || v.option3 === selectedColor;
          return hasFit && hasColor;
        }
        
        return hasFit;
      });
      
      if (!existsForSelectedColor) {
        input.classList.add('hidden');
        input.disabled = true;
        if (label) label.classList.add('hidden');
      } else {
        // Make sure it's visible if it does exist
        input.classList.remove('hidden');
        if (label) label.classList.remove('hidden');
      }
    });
  };
  
  // Run after page load
  window.addEventListener('load', () => {
    setTimeout(() => {
      fixInitialSelection();
      
      // Update button state after initial setup
      updateAddToCartButton();
    }, 50); 
  });

  // Force size dropdown to show placeholder on page load
  window.addEventListener('load', () => {
    setTimeout(() => {
      const sizeSelects = Array.from(document.querySelectorAll('select')).filter(s => 
        window.lyIsOption(s, 'size') && s.name.startsWith('options[')
      );
      sizeSelects.forEach(s => {
        const placeholderOption = Array.from(s.options).find(opt => !opt.value);
        if (placeholderOption) {
          s.value = '';
        }
      });
    }, 100);
  });
}